<div class="super-admin-bar">
  <span class="super-admin-label">
    <span class="material-icons">shield</span>
    <span class="sa-bar-text">Super Admin</span>
  </span>

  <div class="super-admin-actions">
    <button
      type="button"
      class="sa-btn"
      [class.sa-btn-active]="state.enabled"
      [disabled]="saving"
      (click)="toggleIncidentBanner()"
      [attr.aria-pressed]="state.enabled"
      [attr.aria-label]="'Incident banner: ' + (state.enabled ? 'ON' : 'OFF')"
    >
      <span class="material-icons">{{ state.enabled ? 'campaign' : 'notifications_off' }}</span>
      <span class="sa-bar-text">Incident banner: {{ state.enabled ? 'ON' : 'OFF' }}</span>
    </button>

    <button type="button" class="sa-btn" [disabled]="saving" (click)="openEditDialog()" aria-label="Edit message">
      <span class="material-icons">edit</span>
      <span class="sa-bar-text">Edit message</span>
    </button>
  </div>
</div>
